// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2Vzkr","label":"LabeledBox_label__3X9aR"};